import { ChangeDetectionStrategy, Component, contentChildren, effect, input, output } from '@angular/core';

import { BaasTile } from '../baas-tile/baas-tile';
import { BaasTileOptions } from '../baas-tile-options.type';

@Component({
    selector: 'baas-tile-group',
    templateUrl: './baas-tile-group.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasTile]
})
export class BaasTileGroup {
    readonly tiles = input<BaasTileOptions[]>();
    readonly favorite = output<boolean | { id: number | string; value: boolean }>();
    readonly contentTiles = contentChildren(BaasTile);

    constructor() {
        effect(() => {
            this.contentTiles().forEach((tile) => {
                tile.favorite.subscribe((data) => this.favoriteClicked(tile));
            });
        });
    }

    protected favoriteClicked(event) {
        this.favorite.emit(event);
    }
}
